import styled, { css } from 'styled-components';

import theme from '@/theme';

import { device } from '@/styles/helpers';

export const overlayStyle = {
  opacity: '1',
  borderRadius: '12px',
  zIndex: 10,
};

export const overlayInnerStyle = {
  background: theme.grayLightColor,
  maxWidth: '240px',
  borderRadius: '12px',
  border: 'none',
  color: theme.whiteColor,
  fontSize: '14px',
  lineHeight: '20px',
  textAlign: 'center' as const,
  wordBreak: 'break-word' as const,
};

export const ScPrizeWheel = styled.div`
  position: relative;
  z-index: 10;
  height: 100%;
`;

export const ScWinningPrize = styled.div<{ isOpen: boolean }>`
  overflow: ${({ isOpen }) => (isOpen ? 'scroll' : 'hidden')};
  height: 100%;
  background-color: ${({ theme }) => theme.blackColor};
  border-radius: 50%;

  &::-webkit-scrollbar {
    display: none;
  }

  & .inside {
    max-width: 324px;
    width: 100%;
    margin: 0 auto;
    padding: 121px 0 95px;

    &.de {
      padding: 95px 0;
    }

    ${({ isOpen }) =>
      !isOpen &&
      css`
        height: 100%;
      `};

    @media (${device.mobile}) {
      &,
      &.de {
        max-width: 220px;
        padding: 50px 0 57px;
      }
      &.de {
        padding-top: 30px;
      }
    }
  }

  & .congrats {
    font-size: 22px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.01em;
    margin-bottom: 32px;
    text-align: center;
    text-transform: uppercase;

    @media (${device.mobile}) {
      font-size: 16px;
      font-weight: 700;
      line-height: 20px;
      margin-bottom: 16px;
    }
  }

  & .description {
    font-size: 16px;
    font-weight: 700;
    line-height: 28px;
    letter-spacing: 0.01em;
    text-align: center;

    @media (${device.mobile}) {
      font-size: 14px;
      margin-bottom: 4px;
    }
  }

  & .prize-info {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0 32px;

    @media (${device.mobile}) {
      margin: 4px 0 16px;
    }
  }

  & .prize {
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    letter-spacing: 0.03em;
    margin-right: 8px;
    text-transform: capitalize;

    @media (${device.mobile}) {
      font-size: 20px;
      line-height: 28px;
      margin-right: 8px;
    }
  }

  & .info {
    position: relative;
    display: inline-flex;
    cursor: pointer;

    & > svg {
      width: 24px;
      height: 24px;
      object-fit: contain;
      path {
        fill: #fff;
      }
    }
  }

  & .btn-container {
    position: relative;
    max-width: 280px;
    width: 100%;
    margin: 0 auto;

    @media (${device.mobile}) {
      max-width: none;
    }
  }

  & .btn_wrapper {
    display: flex;
    justify-content: center;
  }
`;

export const ScTermsSection = styled.div<{ isOpen: boolean }>`
  position: relative;
  margin-top: 16px;

  & .header {
    padding-bottom: 24px;
  }

  .content-box {
    display: grid;
    grid-template-rows: ${({ isOpen }) => (isOpen ? '1fr' : '0fr')};
    transition: grid-template-rows 0.2s ease 0s;

    & .content {
      position: relative;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      word-break: break-word;
      text-align: left;
    }

    & .bonus {
      text-transform: capitalize;
    }
  }
`;

export const ScTermsButton = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  text-transform: capitalize;
  cursor: pointer;
  margin-bottom: 8px;
  column-gap: 8px;
  font-size: 14px;
  line-height: 20px;

  & > svg {
    transition: rotate 0.2s ease-in-out;
    rotate: ${({ isOpen }) => (isOpen ? '180deg' : '0deg')};
    path {
      stroke: ${({ theme }) => theme.whiteColor};
    }
  }

  @media (hover: hover) {
    &:hover {
      & > svg {
        rotate: 180deg;
      }
    }
  }
`;
